import { Icon } from '@chakra-ui/react';

export const CopyAddressConfirmedIcon = ({ width }: { width: string }) => {
	return (
		<Icon
			w={width}
			h={width}
			viewBox="0 0 14 14"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M12.9031 6.71456V7.25122C12.9024 8.50914 12.4951 9.73312 11.7419 10.7406C10.9887 11.7481 9.93003 12.4852 8.72374 12.8418C7.51745 13.1985 6.22819 13.1557 5.04822 12.7197C3.86826 12.2838 2.86083 11.4781 2.17618 10.4228C1.49152 9.36758 1.16633 8.11926 1.24909 6.86407C1.33186 5.60889 1.81815 4.41408 2.63545 3.45785C3.45274 2.50162 4.55724 1.8352 5.78423 1.55797C7.01121 1.28075 8.29494 1.40759 9.44395 1.91956"
				stroke="#FF3F3F"
				strokeWidth="1.4"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M12.9025 2.5835L7.06921 8.42266L5.31921 6.67266"
				stroke="#FF3F3F"
				strokeWidth="1.4"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>{' '}
		</Icon>
	);
};
